export enum SousTypeTauxEnum {
  FixeRegulier = 'FIXE_REGULIER',
  FixeRevisable = 'FIXE_REVISABLE',
  VariableRegulier = 'VARIABLE_REGULIER',
  VariableReduit = 'VARIABLE_REDUIT',
  VariableProtege = 'VARIABLE_PROTEGE'
}
